// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63330fbc","455":"412046ec","750":"4a7cde00"}[chunkId] + ".chunk.js";
};